import React, { useState, useEffect, useContext } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import RecentDesigns from '../RecentDesigns';
import { useSelector, useDispatch } from 'react-redux';
import selectors from '@state/selectors';
import actions from '@state/actions';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { StudioContext } from '@utils/DOIgnition/StudioContext';
import TabTemplates from '../TabTemplates';
import Loading from '@components/Loading';
import { IDesign } from '@state/designs/types';
import { createFromTemplate, findDefaultName } from '@state/designs/utils';
const uuid = require('react-uuid');

const StudioContent:React.FC<IProps> = (props, state:IState) => {
  const {copyTemplate, setCopyTemplate, currentDesigns, setCurrentDesigns, globalDesigns, setGlobalDesigns,
    options, setOptions, value, setValue, loadingMoreDesigns, setLoadingMoreDesigns } = useContext(StudioContext);
  const authContext = useContext(AuthContext);

  const dispatch = useDispatch();

  const designsResponse = useSelector(selectors.designs.getDesignResponse);

  const fetchDesigns = (option: string, value?: string) => {
    const query = createQuery(option, value);
    return new Promise<IDesign[] | undefined>((resolve, reject) => {
      dispatch(actions.designs.fetchDesigns(query, (result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  } 

  const handleUpdateDesign = (design: any, action: string) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.updateDesign(design, action, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  }

  const handleUpdateDesignDelete = (design: any, action: string) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.updateDesigndelete(design, action, true, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  }

  const createQuery=(option: string, value?: string)=>{
    var finalQuery = "";
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    if (option === "start") {
      finalQuery = `?filter=c.createdBy.email=%27${userData.email}%27 and c.designStatus=%27ACTIVE%27&orderby=c.updateDate DESC&start=0&pagelength=15`;
    } else if (option === "names") {
      finalQuery = `?filter=c.createdBy.email=%27${userData.email}%27 and c.formatName LIKE "%untitled%" and c.designStatus=%27ACTIVE%27&orderby=c.updateDate DESC&start=0&pagelength=200`;
    } else if (option === "nameDuplicate" && value) {
      finalQuery = `?filter=c.createdBy.email=%27${userData.email}%27 and c.formatName LIKE "%copy of ${value}%" and c.designStatus=%27ACTIVE%27&orderby=c.updateDate DESC&start=0&pagelength=200`;
    } else if (option === "favorites") {
      finalQuery = `?filter=c.createdBy.email=%27${userData.email}%27 and c.favorite=true and c.designStatus='ACTIVE'&orderby=c.updateDate DESC&start=0&pagelength=15`;
    } else if (option === "shared") {
      finalQuery = `?filter=c.designStatus='ACTIVE' and (ARRAY_CONTAINS(c.usersPermission, {"email": "${userData.email}", "permission": 1}) OR ARRAY_CONTAINS(c.usersPermission, {"email": "${userData.email}", "permission": 0}))&orderby=c.updateDate DESC&start=0&pagelength=15`;
    } 
    
    return finalQuery;
  }

  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const run = async () => {
      let newGlobalDesigns: IDesign[][] = [];
      let tabOptions : string[] = ["RECENT"];
      const designsResult = await fetchDesigns("start");
      if (designsResult?.length) {
        newGlobalDesigns = [[...designsResult]];
        setCurrentDesigns(designsResult);
        setGlobalDesigns([...newGlobalDesigns]);
        props.setHasDesigns(true);
      }
      props.setIsLookingForDesigns(false);

      const favoriteDesignsResult = await fetchDesigns("favorites");
      if (favoriteDesignsResult?.length) {
        tabOptions = [...tabOptions, "FAVORITES"];
        newGlobalDesigns = [...newGlobalDesigns, [...favoriteDesignsResult]];
        setOptions([...tabOptions]);
        setGlobalDesigns([...newGlobalDesigns]);
      }

      const sharedDesignsResult = await fetchDesigns("shared");
      if (sharedDesignsResult?.length) {
        tabOptions = [...tabOptions, "SHARED"];
        newGlobalDesigns = [...newGlobalDesigns, [...sharedDesignsResult]];
        setOptions([...tabOptions]);
        setGlobalDesigns([...newGlobalDesigns]);
      }
    }
    if (globalDesigns.length===0)run();
  }, []);

  useEffect(() => {
    if (options.length) {
      const valueIndex = value === "RECENT" ? 0 :  value === "FAVORITES" ? 1: 2 ;
      if (valueIndex >= 0 && globalDesigns?.length > 0 && globalDesigns[valueIndex]) {
        setCurrentDesigns(globalDesigns[valueIndex])
      }
    }
  }, [value]);

  useEffect(() => {
    if (copyTemplate) finishSaveDesigns(copyTemplate);
  }, [copyTemplate]);

  useEffect(() => {
    if (designsResponse?.design && globalDesigns) {
      let design = designsResponse?.design;
      const newRecentDesigns = addDesign(design, 0);
      if (design.favorite === true) addDesign(design, 1);
      setValue("RECENT");
      setCurrentDesigns(newRecentDesigns);
      setIsSaving(false);
      var toScroll = document.getElementById(`scroll-top`);
      if (toScroll !== null) {
        toScroll.scrollIntoView({behavior: 'smooth', block: 'nearest'});
      }
    }
  }, [designsResponse]);

  const addDesign = (item: any, index: number) => {
    var newDesigns: any = [];
    var newGlobalDesigns = globalDesigns;
    if (newGlobalDesigns ) {
      if (newGlobalDesigns[index] && newGlobalDesigns[index].length < 14) {
        newDesigns = [item, ...newGlobalDesigns[index]];
      } else {
        if (newGlobalDesigns[index]) newDesigns = [item, ...newGlobalDesigns[index].slice(0, 14)];
      }
      newGlobalDesigns[index] = newDesigns;
      setGlobalDesigns(newGlobalDesigns);
    }
    return newDesigns;
  }

  const removeDesign = (item: any, index: number) => {
    var newDesigns: any = globalDesigns[index];
    var newGlobalDesigns = globalDesigns;
    const designIndex = newGlobalDesigns[index].findIndex((design: any) => (design.id === item.id));
    if (designIndex >= 0) {
      newDesigns = [
        ...newGlobalDesigns[index].slice(0, designIndex),
        ...newGlobalDesigns[index].slice(designIndex + 1)
      ]
    }
    newGlobalDesigns[index] = newDesigns;
    setGlobalDesigns(newGlobalDesigns);
    return newDesigns;
  }

  const updateStateDesign = (item: any, index: number) => {
    var newDesigns: any = globalDesigns[index];
    var newGlobalDesigns = globalDesigns;
    const designIndex = newGlobalDesigns[index].findIndex((design: any) => (design.id === item.id));
    if (designIndex >= 0) {
      newDesigns = [
        item,
        ...newGlobalDesigns[index].slice(0, designIndex),
        ...newGlobalDesigns[index].slice(designIndex + 1)
      ]
    }
    newGlobalDesigns[index] = newDesigns;
    setGlobalDesigns(newGlobalDesigns);
    return newDesigns;
  }

  const finishSaveDesigns = async (design: any) => {
    if (isSaving === false) {
      setIsSaving(true);
      try {
          const designsResult: any = await fetchDesigns("names");
          var name = findDefaultName(designsResult);
          const userData = {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
          };
          const date = new Date();
          const newDesign: IDesign = {
            id: uuid(),
            createdBy: userData,
            entityType: "DESIGN",
            name: name,
            favorite: false,
            previews: design.previews,
            parsedTree: design.parsedTree,
            tags: design.tags,
            createdDate: date,
            updateDate: date,
            updatedBy: userData,
            designStatus: "ACTIVE",
          }
          const designRequest = {
            design: newDesign,
          }
          setCopyTemplate(undefined);
          const response = await createFromTemplate(dispatch, designRequest);
          setIsSaving(false);
          window.open(`/editor/design/${newDesign.id}`);
      } catch (error) {
        console.error(error);
        setIsSaving(false);
        handleDesignError();
      }
    }
  }

  const handleDesignError = () => {
    props.handleWarningScreen(
      true, "Create Design Error",
      `The design could not be created, try again later.`,
      "", undefined, "OKAY", "Design could not be created", []
    );
  }

  const duplicateDesign = (id: string, owner: string) => {
    return new Promise((resolve, reject) => {
      const userData = {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
      };
      let keepFolder = owner===userData.email;

      dispatch(actions.designs.duplicateDesign({id: id,userData: userData, keepFolder: keepFolder, updateFolderCounter: keepFolder}, (result: any, error: any) => {
        if (error) {
          reject(error);
        }
        else {
          resolve(result);
        }
      }))
    })
  }

  const handleDuplicate = async (item: any) => {
    try {
      const designDuplicated:any = await duplicateDesign(item.id, item!.createdBy.email);
      window.open(`/editor/design/${designDuplicated.id}`);
    } catch (error) {
      props.handleWarningScreen(
        true, "Create a Copy & Edit",
        `The design was not duplicated, please try later.`,
        "", undefined, "OKAY", "Duplicate design process failure",[]
      );
      console.error(error);
    }
  }

  const handleFavorite = async (item: any) => {
    item.favorite = item.favorite === true ? false : true;
    var updatedDesign: any = await handleUpdateDesign(item, 'FAVORITES');
    if (updatedDesign.status === 200) {
      var newGlobalDesigns = globalDesigns;
      var favoriteDesignsResult: any = [];
      var updatedRecentDesigns = updateStateDesign(item, 0);
      if (globalDesigns[1]?.length === 15 && item.favorite === false) {
        favoriteDesignsResult = await fetchDesigns("favorites");
        newGlobalDesigns[1] = favoriteDesignsResult;
        setGlobalDesigns(newGlobalDesigns);
      } else {
        if (item.favorite === true) {
          setOptions(["RECENT", "FAVORITES"]);
          favoriteDesignsResult = addDesign(item, 1);
        } else {
          favoriteDesignsResult = removeDesign(item, 1);
        }
      }
      if (favoriteDesignsResult.length > 0) {
        if (value === "FAVORITES") setCurrentDesigns(favoriteDesignsResult);
        else setCurrentDesigns(updatedRecentDesigns);
      } else {
        setOptions(["RECENT"]);
        setValue("RECENT")
        setCurrentDesigns(updatedRecentDesigns);
      }
    }
  }

  const handleEdit = async (item: any) => {
    var updatedRecentDesigns = updateStateDesign(item, 0);
    var updatedFavoriteDesigns = updateStateDesign(item, 1);
    var newGlobalDesigns = [[],[]];
    newGlobalDesigns[0] = updatedRecentDesigns;
    newGlobalDesigns[1] = updatedFavoriteDesigns;
    setGlobalDesigns(newGlobalDesigns);
    if (value === "FAVORITES") setCurrentDesigns(updatedFavoriteDesigns);
    else setCurrentDesigns(updatedRecentDesigns);
  }

  const handleAskDelete = (item: any) => {
    props.handleWarningScreen(
      true, "Delete Design",
      `If you delete this design you will not be able to access it again.`,
      "CANCEL", () => {handleDelete(item)}, "DELETE", "", []
    );
  }

  const handleDelete = async (item: IDesign) => {
    setLoadingMoreDesigns(true);
    item.designStatus = 'INACTIVE';
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    item.updatedBy = userData;
    try {
      props.handleWarningScreen(
        true, "Delete Design",
        `If you delete this design you will not be able to access it again.`,
        "", () => {return false;}, "DELETING...", "", []
      );
      var updatedDesign: any = await handleUpdateDesignDelete(item, 'DELETE');
      if (updatedDesign.status === 200) {
        props.handleWarningScreen(
          true, "Delete Design",
          `The design was deleted successfully.`,
          "", () => {handleFinishDelete(item)}, "OKAY", "", []
        );
      } else {
        throw new Error;
      }
    } catch(e) {
      props.handleWarningScreen(
          true, "Delete Design",
          `The design was not deleted, please try later...`,
          "", undefined, "OKAY", "Delete design process failure", []
      );
    }
    setLoadingMoreDesigns(false);
  }

  const handleFinishDelete = async (item: any) => {
    props.handleWarningScreen(
      false, "", ``, "", undefined, "", "", []
    );
    var newGlobalDesigns = globalDesigns;
    if (newGlobalDesigns[1]?.length === 15) {
      newGlobalDesigns[1] = await fetchDesigns("favorites");
      setGlobalDesigns(newGlobalDesigns);
    } else {
      newGlobalDesigns[1] = removeDesign(item, 1);
    }
    if (newGlobalDesigns[0]?.length === 15) {
      newGlobalDesigns[0] = await fetchDesigns("start");
      setGlobalDesigns(newGlobalDesigns);
    } else {
      newGlobalDesigns[0] = removeDesign(item, 0);
    }
    if (newGlobalDesigns[1]?.length === 0) {
      setOptions(["RECENT"]);
      setValue("RECENT");
      setCurrentDesigns(newGlobalDesigns[0]);
      if (newGlobalDesigns[0]?.length === 0) await fetchDesigns("start");
    } else {
      if (value === "RECENT") setCurrentDesigns(newGlobalDesigns[0]);
      else setCurrentDesigns(newGlobalDesigns[1]);
    }
  }

  const onActions = (item:any, action: string) => {
    if (action === "DUPLICATEEDIT") handleDuplicate(item);
    if (action === "FAVORITEDESIGN") handleFavorite(item);
    if (action === "DELETE") handleAskDelete(item);
    if (action === "add") handleEdit(item);
  }

  return (
    <S.Root
      id="scrollable-templates"
      displayValue={props.shouldDisplay ? 'auto' : 'none'}
      heightValue={props.hasDesigns || props.isLookingForDesigns ? 'calc(100% - 190px)' : 'calc(100% - 390px)'}
    >
      { props.isLookingForDesigns &&
          <S.LoadingContainer>
            <Loading 
              id={"loading-designs"}
              containerStyle={{justifyContent: 'center'}}
            />
          </S.LoadingContainer>
      } 
      <S.Content>
        { props.hasDesigns &&
          <RecentDesigns
            options={options}
            value={value}
            setValue={setValue}
            currentDesigns={currentDesigns}
            onActions={onActions}
            loading={loadingMoreDesigns}
            isLookingForDesigns={props.isLookingForDesigns}
            profile={authContext && authContext.userData && authContext.userData.profile ?authContext?.userData.profile: {}}
          />
        }
        <TabTemplates
          addDesign={finishSaveDesigns}
        />
      </S.Content>
    </S.Root >
  );
}

export default StudioContent;